// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2h2kx","additionalInfo":"AgreementModal_additionalInfo__rTGTy"};